import { useRef, useEffect, useCallback, DependencyList } from 'react';

const useRefCallback = (callback: Function, deps: DependencyList = []) => {
    const ref = useRef(callback);

    useEffect(
        () => {
            ref.current = callback;
        },
        [callback, deps]
    );

    return useCallback(
        () => {
            const callbackFn = ref.current;

            return callbackFn();
        },
        [ref]
    );
};

export default useRefCallback;
